import Group from "../Models/Group";
import HttpService from "./HttpService";
import ScoreCard from "../Models/ScoreCard";
import PlayerPair from "../Models/PlayerPair";
import UpdateScoreCardsRequest from "../Requests/ScoreCards/UpdateScoreCardsRequest";

export default class GameService
{
  public async updateScoreCard(playerPair: PlayerPair, scoreCard: ScoreCard): Promise<void>
  {
    const url = '/Game/ScoreCard';
    const request: UpdateScoreCardsRequest = {
      playerPairId: playerPair.id,
      cubeId: scoreCard.cube.id,
      completed: scoreCard.completed,
      livesRemaining: scoreCard.livesRemaining,
      simplifyUsed: scoreCard.simplifyUsed,
      swapUsed: scoreCard.swapUsed,
    }
    await HttpService.put<Group>(url, request);
  }
}

export const gameService = new GameService();